import React, { useState } from 'react';
import api from '../context/api';

const ACCOUNT_ID = 'ad871556-4e5d-4426-8e08-134c0d9400fa'; // display only

const PaymentPage = () => {
  const [formData, setFormData] = useState({
    amount: '',
    customerName: '',
    customerMsisdn: '',
    description: '',
  });
  const [loading, setLoading] = useState(false);
  const [transactionId, setTransactionId] = useState('');
  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await api.post('/payment/initiate', formData);
      setTransactionId(response.data.transactionId || response.data.id || 'N/A');
      setStatus('Pending');
      alert('Payment initiated! Check your phone for approval.');
    } catch (err) {
      console.error('Payment initiate error:', err?.response || err);
      const backendMessage =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        (typeof err?.response?.data === 'string' ? err.response.data : null);
      const msg = backendMessage || err.message || 'Payment failed!';
      alert(msg);
    } finally {
      setLoading(false);
    }
  };

  const checkStatus = async () => {
    if (!transactionId) return;
    try {
      const response = await api.get(`/payment/status/${transactionId}`);
      const currentStatus = response.data.status || response.data.state || 'Unknown';
      setStatus(currentStatus);
      alert(`Payment Status: ${currentStatus}`);
    } catch (err) {
      console.error('Payment status error:', err?.response || err);
      const backendMessage =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        (typeof err?.response?.data === 'string' ? err.response.data : null);
      const msg = backendMessage || err.message || 'Failed to check status!';
      alert(msg);
    }
  };

  return (
    <div style={{ maxWidth: 500, margin: '50px auto', padding: 20, border: '1px solid #ccc', borderRadius: 8 }}>
      <h2>Business Pay Payment</h2>
      <p>Account ID: <strong>{ACCOUNT_ID}</strong></p>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Name:</label>
          <input name="customerName" value={formData.customerName} onChange={handleChange} required />
        </div>
        <div>
          <label>Phone:</label>
          <input name="customerMsisdn" value={formData.customerMsisdn} onChange={handleChange} required />
        </div>
        <div>
          <label>Amount:</label>
          <input name="amount" type="number" value={formData.amount} onChange={handleChange} required min="0.1" />
        </div>
        <div>
          <label>Description:</label>
          <input name="description" value={formData.description} onChange={handleChange} />
        </div>
        <button type="submit" disabled={loading}>
          {loading ? 'Processing...' : 'Send Payment'}
        </button>
      </form>

      {transactionId && (
        <div style={{ marginTop: 20 }}>
          <p>Transaction ID: {transactionId}</p>
          <p>Status: {status}</p>
          <button onClick={checkStatus}>Check Status</button>
        </div>
      )}
    </div>
  );
};

export default PaymentPage;
